import Thanks from "./thanks";

function App() {
  return (
    <div className="App">
      <Thanks />
    </div>
  );
}

export default App;
